export default {
  data() {
    return {
      applicationStatusInfoMap: {
        1001: {
          1000: {
            name: window.$t('commonForm-1.key338', { cm: '编辑中' }),
            color: '#208BEC',
            flag: 'editFlag',
            svgType: 'editFlag',
          },
          1001: {
            name: window.$t('commonForm-1.key339', { cm: '已撤回' }),
            color: '#FF9C53',
            flag: 'withDrawFlag',
            svgType: 'withDrawFlag',
          },
          1002: {
            name: window.$t('commonForm-1.key67', { cm: '已驳回' }),
            color: '#FA4858',
            flag: 'rejectFlag',
            svgType: 'rejectFlag',
          },
        },
        1002: {
          1000: {
            name: window.$t('commonForm-1.key252', { cm: '审批中' }),
            color: '#208BEC',
            flag: 'processFlag',
            svgType: 'processFlag',
          },
        },
        1003: {
          1000: {
            name: window.$t('commonForm-1.key66', { cm: '已通过' }),
            color: '#41B43B',
            flag: 'successFlag',
            svgType: 'successFlag',
          },
        },
        1011: {
          1000: {
            name: window.$t('commonForm-1.key347', { cm: '已更改' }),
            color: '#1E78C8',
            flag: 'processFlag',
            svgType: 'processFlag',
          },
        },
        1012: {
          1000: {
            name: window.$t('commonForm-1.key348', { cm: '已报废' }),
            color: '#8C96B4',
            flag: 'processFlag',
            svgType: 'failureFlag',
          },
        },
      },
      expenseStatusInfoMap: {
        1001: {
          1000: {
            name: window.$t('commonForm-1.key338', { cm: '编辑中' }),
            color: '#208BEC',
            flag: 'editFlag',
            svgType: 'editFlag',
          },
          1001: {
            name: window.$t('commonForm-1.key339', { cm: '已撤回' }),
            color: '#FF9C53',
            flag: 'withDrawFlag',
            svgType: 'withDrawFlag',
          },
          1002: {
            name: window.$t('commonForm-1.key67', { cm: '已驳回' }),
            color: '#FA4858',
            flag: 'rejectFlag',
            svgType: 'rejectFlag',
          },
          1003: {
            name: window.$t('commonForm-1.key349', { cm: '审核驳回' }),
            color: '#FA4858',
            flag: 'rejectFlag',
            svgType: 'rejectFlag',
          },
          1004: {
            name: window.$t('commonForm-1.key340', { cm: '开票驳回' }),
            color: '#FA4858',
            flag: 'rejectFlag',
            svgType: 'rejectFlag',
          },
        },
        1002: {
          1000: {
            name: window.$t('commonForm-1.key252', { cm: '审批中' }),
            color: '#208BEC',
            flag: 'processFlag',
            svgType: 'processFlag',
          },
        },
        1003: {
          1000: {
            name: window.$t('commonForm-1.key709', { cm: '待审核' }),
            color: '#41B43B',
            flag: 'successFlag',
            svgType: 'successFlag',
          },
        },
        1004: {
          1000: {
            name: window.$t('commonForm-1.key350', { cm: '审核通过' }),
            color: '#41B43B',
            flag: 'successFlag',
            svgType: 'successFlag',
          },
        },
        1005: {
          1000: {
            name: window.$t('commonForm-1.key342', { cm: '已付款' }),
            color: '#566D7F',
            flag: 'successFlag',
            svgType: 'successFlag',
          },
        },
        1006: {
          1000: {
            name: window.$t('commonForm-1.key343', { cm: '还款中' }),
            color: '#208BEC',
            flag: 'processFlag',
            svgType: 'rmbFlag',
          },
        },
        1007: {
          1000: {
            name: window.$t('commonForm-1.key345', { cm: '待付款' }),
            color: '#FF800B',
            flag: 'waitPayment',
            svgType: 'rmbFlag',
          },
        },
        1008: {
          1000: {
            name: window.$t('commonForm-1.key351', { cm: '付款中' }),
            color: '#208BEC',
            flag: 'processFlag',
            svgType: 'rmbFlag',
          },
        },
        1015: {
          1000: {
            name: window.$t('commonForm-1.key352', { cm: '取消支付' }),
            color: '#566D7F',
            flag: 'successFlag',
            svgType: 'failureFlag',
          },
        },
        1011: {
          1000: {
            name: window.$t('commonForm-1.key347', { cm: '已更改' }),
            color: '#1E78C8',
            flag: 'processFlag',
            svgType: 'processFlag',
          },
        },
        J_error_proxy: {
          // 少数情况 代提失效场景 前端写死key
          1000: {
            name: '',
          },
        },
      },
      journalStatusInfoMap: {
        // name 值无效 需要取后端返回值信息
        NEW: {
          name: window.$t('commonForm-1.key338', { cm: '编辑中' }),
          color: '#1E78C8',
          flag: 'editFlag',
          imageName: 'stayStatusFlag',
          svgType: 'editFlag',
        },
        SUBMIT: {
          name: window.$t('commonForm-1.key252', { cm: '审批中' }),
          color: '#208BEC',
          flag: 'processFlag',
          imageName: 'approingFlag',
          svgType: 'processFlag',
        },
        SUBMIT_RETURN: {
          name: window.$t('commonForm-1.key339', { cm: '已撤回' }),
          color: '#FF9C53',
          flag: 'withDrawFlag',
          imageName: 'stayStatusFlag',
          svgType: 'withDrawFlag',
        },
        APPROVAL_REJECT: {
          name: window.$t('commonForm-1.key67', { cm: '已驳回' }),
          color: '#FA4858',
          flag: 'rejectFlag',
          imageName: 'stayStatusFlag',
          svgType: 'rejectFlag',
        },
        AUDIT_REJECT: {
          name: window.$t('commonForm-1.key67', { cm: '已驳回' }),
          color: '#FA4858',
          flag: 'rejectFlag',
          imageName: 'stayStatusFlag',
          svgType: 'rejectFlag',
        },
        CHECKED: {
          name: window.$t('commonForm-1.key66', { cm: '已通过' }),
          color: '#41B43B',
          flag: 'successFlag',
          imageName: 'approvalSuccessFlag',
          svgType: 'successFlag',
        },
        POSTED: {
          // 复核通过（已过账）
          name: window.$t('commonForm-1.key66', { cm: '已通过' }),
          color: '#41B43B',
          flag: 'successFlag',
          imageName: 'approvalSuccessFlag',
          svgType: 'successFlag',
        },
      },
      loanBillStatusInfoMap: {
        1001: {
          1000: {
            name: window.$t('commonForm-1.key338', { cm: '编辑中' }),
            color: '#208BEC',
            flag: 'editFlag',
            svgType: 'editFlag',
          },
          1001: {
            name: window.$t('commonForm-1.key339', { cm: '已撤回' }),
            color: '#FF9C53',
            flag: 'withDrawFlag',
            svgType: 'withDrawFlag',
          },
          1002: {
            name: window.$t('commonForm-1.key67', { cm: '已驳回' }),
            color: '#FA6478',
            flag: 'rejectFlag',
            svgType: 'rejectFlag',
          },
          1003: {
            name: window.$t('commonForm-1.key67', { cm: '已驳回' }),
            color: '#FA6478',
            flag: 'rejectFlag',
            svgType: 'rejectFlag',
          },
          1004: {
            name: window.$t('commonForm-1.key340', { cm: '开票驳回' }),
            color: '#FA6478',
            flag: 'rejectFlag',
            svgType: 'rejectFlag',
          },
        },
        1002: {
          1000: {
            name: window.$t('commonForm-1.key252', { cm: '审批中' }),
            color: '#208BEC',
            flag: 'processFlag',
            svgType: 'processFlag',
          },
          1002: {
            name: window.$t('commonForm-1.key252', { cm: '审批中' }),
            color: '#208BEC',
            flag: 'processFlag',
            svgType: 'processFlag',
          },
        },
        1003: {
          1000: {
            // name: window.$t('commonForm-1.key66', { cm: '已通过' }),
            name: window.$t('commonForm-1.key709', { cm: '待审核' }),
            color: '#41B43B',
            flag: 'successFlag',
            svgType: 'successFlag',
          },
          1001: {
            // name: window.$t('commonForm-1.key66', { cm: '已通过' }),
            name: window.$t('commonForm-1.key709', { cm: '待审核' }),
            color: '#41B43B',
            flag: 'successFlag',
            svgType: 'successFlag',
          },
        },
        1004: {
          1000: {
            name: window.$t('commonForm-1.key345', { cm: '待付款' }),
            color: '#FF800B',
            flag: 'waitPayment',
            svgType: 'rmbFlag',
          },
        },
        1005: {
          1000: {
            name: window.$t('commonForm-1.key342', { cm: '已付款' }),
            color: '#566D7F',
            flag: 'successFlag',
            svgType: 'successFlag',
          },
        },
        1006: {
          1000: {
            name: window.$t('commonForm-1.key343', { cm: '还款中' }),
            color: '#208BEC',
            flag: 'processFlag',
            svgType: 'rmbFlag',
          },
        },
        1007: {
          1000: {
            name: window.$t('commonForm-1.key344', { cm: '已还款' }),
            color: '#41B43B',
            flag: 'successFlag',
            svgType: 'successFlag',
          },
        },
        1008: {
          1000: {
            name: window.$t('commonForm-1.key351', { cm: '付款中' }),
            color: '#1E78C8',
            flag: 'processFlag',
            svgType: 'processFlag',
          },
        },
        1009: {
          1000: {
            name: window.$t('commonForm-1.key346', { cm: '已关闭' }),
            color: '#566D7F',
            flag: 'closedFlag',
            svgType: 'rejectFlag',
          },
        },
        1011: {
          1000: {
            name: window.$t('commonForm-1.key347', { cm: '已更改' }),
            color: '#208BEC',
            flag: 'processFlag',
            svgType: 'editFlag',
          },
        },
      },
      salaryPaymentStatusInfoMap: {
        10011001: {
          name: window.$t('commonForm-1.key339', { cm: '已撤回' }),
          color: '#FF9C53',
          flag: 'withDrawFlag',
          svgType: 'withDrawFlag',
        },
        10011002: {
          name: window.$t('commonForm-1.key67', { cm: '已驳回' }),
          color: '#FA6478',
          flag: 'rejectFlag',
          svgType: 'rejectFlag',
        },
        1001: {
          name: window.$t('commonForm-1.key338', { cm: '编辑中' }),
          color: '#208BEC',
          flag: 'editFlag',
          imageName: 'stayStatusFlag',
          svgType: 'editFlag',
        },
        1002: {
          name: window.$t('commonForm-1.key252', { cm: '审批中' }),
          color: '#208BEC',
          flag: 'processFlag',
          imageName: 'approingFlag',
          svgType: 'processFlag',
        },
        1004: {
          name: window.$t('commonForm-1.key345', { cm: '待付款' }),
          color: '#1E78C8',
          flag: 'waitPayment',
          svgType: 'waitPayment',
        },
        1008: {
          name: window.$t('commonForm-1.key553', { cm: '支付中' }),
          color: '#1E78C8',
          flag: 'processFlag',
          svgType: 'processFlag',
        },
        1005: {
          name: window.$t('commonForm-1.key342', { cm: '已付款' }),
          color: '#566D7F',
          flag: 'successFlag',
          svgType: 'successFlag',
        },
      },
      accrualStatusInfoMap: {
        1001: {
          name: window.$t('commonForm-1.key338', { cm: '编辑中' }),
          color: '#208BEC',
          flag: 'editFlag',
          imageName: 'stayStatusFlag',
          svgType: 'editFlag',
        },
        1002: {
          name: window.$t('commonForm-1.key252', { cm: '审批中' }),
          color: '#208BEC',
          flag: 'processFlag',
          imageName: 'approingFlag',
          svgType: 'processFlag',
        },
        1008: {
          name: window.$t('commonForm-1.key339', { cm: '已撤回' }),
          color: '#FF9C53',
          flag: 'withDrawFlag',
          imageName: 'withDrawFlag',
          svgType: 'withDrawFlag',
        },
        1003: {
          // name: window.$t('commonForm-1.key66', { cm: '已通过' }),
          name: window.$t('commonForm-1.key709', { cm: '待审核' }),
          color: '#41B43B',
          flag: 'successFlag',
          imageName: 'approvalSuccessFlag',
          svgType: 'successFlag',
        },
        1009: {
          name: window.$t('commonForm-1.key67', { cm: '已驳回' }),
          color: '#FA6478',
          flag: 'rejectFlag',
          imageName: 'rejectFlag',
          svgType: 'rejectFlag',
        },
        1004: {
          name: window.$t('commonForm-1.key350', { cm: '审核通过' }),
          color: '#41B43B',
          flag: 'successFlag',
          svgType: 'successFlag',
        },
        1006: {
          name: window.$t('commonForm-1.key569', { cm: '冲销中' }),
          color: '#208BEC',
          flag: 'processFlag',
          imageName: 'approingFlag',
          svgType: 'processFlag',
        },
        1007: {
          name: window.$t('commonForm-1.key570', { cm: '冲销完成' }),
          color: '#566D7F',
          flag: 'closedFlag',
          imageName: 'closedFlag',
          svgType: 'failureFlag',
        },
        1010: {
          name: window.$t('commonForm-1.key346', { cm: '已关闭' }),
          color: '#566D7F',
          flag: 'closedFlag',
          imageName: 'closedFlag',
          svgType: 'rejectFlag',
        },
      },
      paymentBatchStatusInfoMap: {
        1002: {
          name: window.$t('commonForm-1.key252', { cm: '审批中' }),
          color: '#208BEC',
          flag: 'processFlag',
          imageName: 'approingFlag',
          svgType: 'processFlag',
        },
        1001: {
          name: window.$t('commonForm-1.key500', { cm: '审批驳回' }),
          color: '#FA6478',
          flag: 'rejectFlag',
          imageName: 'rejectFlag',
          svgType: 'rejectFlag',
        },
        1029: {
          name: window.$t('commonForm-1.key676', { cm: '复核驳回' }),
          color: '#FA6478',
          flag: 'rejectFlag',
          imageName: 'rejectFlag',
          svgType: 'rejectFlag',
        },
        1003: {
          name: window.$t('commonForm-1.key224', { cm: '审批通过' }),
          color: '#41B43B',
          flag: 'successFlag',
          imageName: 'approvalSuccessFlag',
          svgType: 'successFlag',
        },
        1030: {
          name: window.$t('commonForm-1.key677', { cm: '复核通过' }),
          color: '#41B43B',
          flag: 'successFlag',
          imageName: 'approvalSuccessFlag',
          svgType: 'successFlag',
        },
      },
      contractStatusInfoMap: {
        1001: {
          name: window.$t('commonForm-1.key338', { cm: '编辑中' }),
          color: '#208BEC',
          flag: 'editFlag',
          imageName: 'stayStatusFlag',
          svgType: 'editFlag',
        },
        1002: {
          name: window.$t('commonForm-1.key252', { cm: '审批中' }),
          color: '#208BEC',
          flag: 'processFlag',
          imageName: 'approingFlag',
          svgType: 'processFlag',
        },
        1003: {
          name: window.$t('commonForm-1.key339', { cm: '已撤回' }),
          color: '#FF9C53',
          flag: 'withDrawFlag',
          imageName: 'withDrawFlag',
          svgType: 'withDrawFlag',
        },
        1004: {
          name: window.$t('commonForm-1.key66', { cm: '已通过' }),
          color: '#41B43B',
          flag: 'successFlag',
          imageName: 'approvalSuccessFlag',
          svgType: 'successFlag',
        },
        1005: {
          name: window.$t('commonForm-1.key67', { cm: '已驳回' }),
          color: '#FA6478',
          flag: 'rejectFlag',
          imageName: 'rejectFlag',
          svgType: 'rejectFlag',
        },
        1007: {
          name: window.$t('commonForm-1.key603', { cm: '变更中' }),
          color: '#208BEC',
          flag: 'changeFlag',
          imageName: 'changeFlag',
          svgType: 'changeFlag',
        },
        6001: {
          name: window.$t('commonForm-1.key231', { cm: '暂挂' }),
          color: '#FF9C53',
          flag: 'withDrawFlag',
          imageName: 'withDrawFlag',
          svgType: 'failureFlag',
        },
        6002: {
          name: window.$t('commonForm-1.key353', { cm: '已取消' }),
          color: '#7B8D9C',
          flag: 'closedFlag',
          imageName: 'closedFlag',
          svgType: 'rejectFlag',
        },
        6003: {
          name: window.$t('commonForm-1.key354', { cm: '已完成' }),
          color: '#41B43B',
          flag: 'successFlag',
          imageName: 'approvalSuccessFlag',
          svgType: 'withDrawFlag',
        },
        6004: {
          name: window.$t('commonForm-1.key355', { cm: '取消暂挂' }),
          color: '#208BEC',
          flag: 'processFlag',
          imageName: 'processFlag',
          svgType: 'failureFlag',
        },
        oldVersion: {
          name: window.$t('commonForm-1.key413', { cm: '已变更' }),
          color: '#41B43B',
          flag: 'successFlag',
          imageName: 'approvalSuccessFlag',
          svgType: 'successFlag',
        },
      },
      documentStatusInfoMap: {
        1001: {
          name: window.$t('commonForm-1.key338', { cm: '编辑中' }),
          color: '#208BEC',
          flag: 'editFlag',
          imageName: 'stayStatusFlag',
          svgType: 'editFlag',
        },
        1002: {
          name: window.$t('commonForm-1.key604', { cm: '流程中' }),
          color: '#208BEC',
          flag: 'processFlag',
          imageName: 'approingFlag',
          svgType: 'processFlag',
        },
        1003: {
          name: window.$t('commonForm-1.key354', { cm: '已完成' }),
          color: '#41B43B',
          flag: 'successFlag',
          imageName: 'approvalSuccessFlag',
          svgType: 'successFlag',
        },
        1004: {
          name: window.$t('commonForm-1.key605', { cm: '被驳回' }),
          color: '#FA6478',
          flag: 'rejectFlag',
          imageName: 'rejectFlag',
          svgType: 'rejectFlag',
        },
      },
      // 对公收款
      refundStatus: {
        1001: {
          name: window.$t('commonForm-1.key338', { cm: '编辑中' }),
          color: '#208BEC',
          flag: 'editFlag',
          imageName: 'stayStatusFlag',
          svgType: 'editFlag',
        },
        1002: {
          name: window.$t('commonForm-1.key609', { cm: '待收款' }),
          color: '#FF800B',
          flag: 'approingFlag',
          svgType: 'rmbFlag',
        },
        1003: {
          name: window.$t('commonForm-1.key350', { cm: '审核通过' }),
          color: '#41B43B',
          flag: 'successFlag',
          svgType: 'successFlag',
        },
        1004: {
          name: window.$t('commonForm-1.key610', { cm: '已收款' }),
          color: '#41B43B',
          flag: 'successFlag',
          svgType: 'successFlag',
        },
        1009: {
          name: window.$t('commonForm-1.key67', { cm: '已驳回' }),
          color: '#FA6478',
          flag: 'rejectFlag',
          imageName: 'rejectFlag',
          svgType: 'rejectFlag',
        },
      },
    };
  },
};
